import { DatabaseOutlined } from '@ant-design/icons';
import { Alert, Descriptions, Table, Tag } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import ToolWrapper from './components/ToolWrapper';
import arrayToTableData from './utils/tableHelpers';

/**
 * Renders the GetAvailableAssets tool response.
 * Shows all available analysis assets.
 */
function GetAvailableAssetsTool({ item }) {
  const status = item.response?.status || '';
  const availableCharts = item.response?.available_charts || [];
  const availableVerbatims = item.response?.available_verbatims || [];
  const isPending = item.response === null || item.response === undefined;

  // Combine charts and verbatims into a single assets array for display
  const assets = [
    ...availableCharts.map((c) => ({ type: 'chart', ...c })),
    ...availableVerbatims.map((v) => ({ type: 'verbatim', ...v })),
  ];

  const { dataSource, columns } = arrayToTableData(assets);

  return (
    <ToolWrapper toolName="Available Assets" isPending={isPending} icon={<DatabaseOutlined />}>
      {!isPending && (
        <Descriptions column={1} bordered size="small" style={{ marginBottom: 16 }}>
          <Descriptions.Item label="Status">
            <Tag color={status === 'success' ? 'green' : 'red'}>{status}</Tag>
          </Descriptions.Item>
        </Descriptions>
      )}
      {assets.length === 0 ? (
        <Alert message="No assets available" type="info" />
      ) : (
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{ pageSize: 10 }}
          size="small"
        />
      )}
    </ToolWrapper>
  );
}

GetAvailableAssetsTool.propTypes = {
  item: PropTypes.shape({
    response: PropTypes.shape({
      status: PropTypes.string,
      available_charts: PropTypes.arrayOf(
        PropTypes.shape({
          chart_name: PropTypes.string,
          title: PropTypes.string,
        }),
      ),
      available_verbatims: PropTypes.arrayOf(
        PropTypes.shape({
          verbatim_id: PropTypes.string,
          quote_preview: PropTypes.string,
          relevance_score: PropTypes.number,
        }),
      ),
      charts_count: PropTypes.number,
      verbatims_count: PropTypes.number,
      message: PropTypes.string,
    }),
  }).isRequired,
};

export default GetAvailableAssetsTool;
